import { FC, useMemo } from 'react';
import { SxProps, Theme } from '@mui/material';
import Image from "next/legacy/image";
import Link from 'next/link';
import LogoWithDarkText from '../../../public/assets/icons/logo-with-dark-text.svg';
import LogoWithLightText from '../../../public/assets/icons/logo-with-light-text.svg';
import LogoWithText from '../../../public/assets/icons/logo-with-text-2.svg';
import ImageWrapper from '../../images/Image-wrapper';

export interface LogoProps {
	type?: 'light' | 'dark-text' | 'light-text';
	sx?: SxProps<Theme>;
	layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive';
}

// TODO: RD-2377 - delete this logo and use the one in @sweatpals/react-ui-kit
const Logo: FC<LogoProps> = (props) => {
	const { type = 'light', sx = {}, layout } = props;

	const imageSrc = useMemo(() => {
		switch (type) {
			case 'light': return LogoWithText;
			case 'light-text': return LogoWithLightText;
			default: return LogoWithDarkText;
		}
	}, [type]);

	return (
		<Link passHref href="/">
			<ImageWrapper sx={{ cursor: 'pointer', minWidth: '150px', ...sx }}>
				<Image src={imageSrc} alt="Logo" layout={layout} />
			</ImageWrapper>
		</Link>
	);
};

export default Logo;
